import { createRouter, createWebHistory } from "vue-router";
import ConferenceRoutes from "./pages/conference/routes";

const routes = [
	{
		path: "/",
		name: "Home",
		component: () => import("./pages/home"),
		children: [
			{
				path: "/",
				name: "Landing",
				component: () => import("./pages/home/landing.vue"),
				meta: {
					title: "Home",
				},
			},
			{
				path: "/programs",
				name: "Programs",
				component: () => import("./pages/eqa"),
				meta: {
					title: "EQA Programs",
				},
			},
			{
				path: "/programs/quotation",
				name: "Quotation",
				component: () => import("./pages/eqa/quotation/quotation"),
				props: (route) => ({ path: route.path }),
				children: [
					{
						path: "details",
						component: () => import("./pages/eqa/quotation/detailsForm"),
					},
					{
						path: "programs",
						component: () => import("./pages/eqa/quotation/programsForm"),
					},
					{
						path: "success",
						component: () => import("./pages/eqa/quotation/success"),
					},
				],
				meta: {
					title: "Quotation",
				},
			},
			{
				path: "/conference",
				name: "Conference",
				component: () => import("./pages/conference"),
				children: ConferenceRoutes,
				meta: {
					title: "Conference",
				},
			},
			{
				path: "/training",
				name: "Training",
				component: () => import("./pages/training"),
				meta: {
					title: "CPD Trainings",
					metaTags: [
						{
							name: "description",
							content:
								"HuQAS offers specialized laboratory centered training that is aimed towards improving lab personel and lab testing.",
						},
						{
							property: "og:description",
							content:
								"HuQAS offers specialized laboratory centered training that is aimed towards improving lab personel and lab testing.",
						},
					],
				},
			},
			{
				path: "/training/:slug",
				name: "Training_Details",
				component: () => import("./pages/training/trainingDetails"),
				props: (route) => ({ params: route.params }),
				meta: {
					title: "Training Details",
				},
			},
			{
				path: "/mentorship",
				name: "Mentorship",
				component: () => import("./pages/mentorship"),
				meta: {
					title: "Mentorship",
				},
			},
			{
				path: "/mentorship/quote",
				name: "Mentorship Quote",
				component: () => import("./pages/mentorship/quotationForm"),
				meta: {
					title: "Mentorship Quote",
				},
			},
			{
				path: "/news",
				name: "News",
				component: () => import("./pages/news"),
				meta: {
					title: "News",
				},
			},
			{
				path: "/news/article/:slug",
				name: "News Article",
				component: () => import("./pages/news/newsArticle"),
				props: (route) => ({ params: route.params }),
				meta: {
					title: "News Article",
				},
			},
			{
				path: "/about",
				name: "About",
				component: () => import("./pages/about"),
				meta: {
					title: "About Us",
				},
			},
			{
				path: "/contact-us",
				name: "Contact Us",
				component: () => import("./pages/contacts"),
				meta: {
					title: "Contact Us",
				},
			},
		],
		meta: {
			title: "Home",
		},
	},
	{
		path: "/workshop/tz",
		name: "Workshop",
		component: () => import("./pages/workshop"),
		meta: {
			title: "Tanzania Workshop",
		},
	},
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		component: () => import("./pages/errors/error_404.vue"),
		meta: {
			title: "Not Found",
		},
	},
];

const router = createRouter({
	history: createWebHistory(),
	scrollBehavior() {
		return { top: 0 };
	},
	routes,
});

router.beforeEach((to, from, next) => {
	const siteTitle = "Human Quality Assessment Services (HuQAS)";
	const pageTitle = to.meta.title;

	if (pageTitle) {
		document.title = `${pageTitle} | ${siteTitle}`;
	} else {
		document.title = siteTitle;
	}
	next();
});

export default router;
